
// Dependencies
import Vue from 'vue';
// @ts-ignore
import TreeView from 'vue-json-tree-view';
import VeeValidate, { Validator } from 'vee-validate';
// @ts-ignore
import Spanish from 'vee-validate/dist/locale/es';
// @ts-ignore
import VueGeolocation from 'vue-browser-geolocation';

// Local
import App from './App.vue';
import router from './router';
import store from './store';

// Setup validations locale
Validator.localize ('es', Spanish);

// Register
Vue.use (TreeView);
Vue.use (VeeValidate);
Vue.use (VueGeolocation);

// Setup
Vue.config.productionTip = false;

// Done
new Vue ({
	router,
	store,
	render: h => h (App)
}).$mount ('#app');
